export default __webpack_public_path__ + "static/media/ClassicDebut.dafab2b3.jpg";